import { ActiveNavLink } from "components/common/ActiveNavLink";
import { useHierarchyContext } from "contexts/AppSettingsContext";
import { getHierarchyBaseUrl } from "contexts/hierarchy/getHierarchyBaseUrl";

/**
 * Renders a link to the current hierarchy's parent node (or a corporate link when
 * no hierarchy is selected and a corporate hierarchy exists).
 *
 * @returns A link element to the parent hierarchy when available, otherwise an empty fragment.
 */
export const ParentLink = (): React.ReactNode => {
  const hierarchyContext = useHierarchyContext();

  // Current hierarchy information
  const parent =
    hierarchyContext &&
    hierarchyContext.hierarchy &&
    hierarchyContext.hierarchyNodes.find(
      (h) => h.hierarchyTag === hierarchyContext.hierarchy!.parentTag,
    );

  return parent && hierarchyContext?.hierarchy?.level !== "Corporate" ? (
    <>
      <h5>{parent.level}</h5>
      <div className="mb-2">
        <ActiveNavLink
          id="hierarchylinks-parent-link"
          to={`${getHierarchyBaseUrl(parent)}`}
        >
          {parent.name}
        </ActiveNavLink>
        <hr className="mt-3" />
      </div>
    </>
  ) : hierarchyContext?.hierarchy?.level === "Corporate" ? null : (
    <div>
      <ActiveNavLink
        id="hierarchylinks-corporate"
        to={"/Corporate"}
      >
        Corporate
      </ActiveNavLink>
      <hr className="mt-3" />
    </div>
  );
};

ParentLink.displayName = "ParentLink";
